var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { actions as formActions } from 'react-redux-form';
import { withRouter } from "../componentWrappers";
import templatesAPI from "./TemplatesAPI";
import thesauriAPI from "../Thesauri/ThesauriAPI";
import relationTypesAPI from "../RelationTypes/RelationTypesAPI";
import TemplateCreator from "./components/TemplateCreator";
import { actions } from "../BasicReducer";
import RouteHandler from "../App/RouteHandler";
import { OnTemplateLoaded } from "./components/OnTemplateLoaded";
import { prepareTemplate } from "./actions/templateActions";

class EditTemplateComponent extends RouteHandler {
  static async requestState(requestParams) {
    const { templateId } = requestParams.data;
    const [templates, thesauris, relationTypes] = await Promise.all([
    templatesAPI.get(requestParams.onlyHeaders()),
    thesauriAPI.get(requestParams.onlyHeaders()),
    relationTypesAPI.get(requestParams.onlyHeaders())]
    );

    const template = templates.find((tmpl) => tmpl._id === templateId);

    return [
    formActions.load('template.data', prepareTemplate(template)),
    actions.set('thesauris', thesauris),
    actions.set('templates', templates),
    actions.set('relationTypes', relationTypes)];

  }

  componentDidMount() {
    this.context.store.dispatch(formActions.reset('template.data'));
  }

  render() {
    return (/*#__PURE__*/
      _jsx("div", { className: "settings-content sm-footer-extra-row" }, void 0, /*#__PURE__*/
      _jsx(OnTemplateLoaded, {}, void 0, /*#__PURE__*/
      _jsx(TemplateCreator, {})
      )
      ));

  }
}

const EditTemplate = withRouter(EditTemplateComponent);
export { EditTemplate, EditTemplateComponent };